import { isCustomUI } from '../../utils/isCustomUI';

export type AppType = 'CustomUI' | 'UIKit';

export const getAppType = (extension: Parameters<typeof isCustomUI>[0]): AppType =>
	isCustomUI(extension) ? 'CustomUI' : 'UIKit';
